<template>
  <div class="conmon-top customer-label">
    <el-row>
      <el-col :span="24">
        <div class="grid-content-one" style="text-align: left">
          <h4><i class="el-icon-warning" style="margin:0 5px 0 22px;"></i>说明</h4>
          <div class="tip-content" style="text-align: left;padding-left:36px;">
            首先被标记在内容（如微页面、公众号二维码、大转盘等）上，当客户与内容产生交互行为（如访问、点击、扫码等）便会打上该内容标签，通过标签可以  有效掌握客户的阅读偏好和兴趣爱好
          </div>
        </div>
      </el-col>
    </el-row>
    <el-container>
      <el-main style="padding: 0">
        <el-row  class="search-title common-table-top" style="margin-top: 20px;padding-right:0">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>标签列表</span>
          </el-col>
          <el-col :span="20" style="text-align:right">
            <span style="margin-left: 20px">搜索标签：</span>
            <el-autocomplete
              class="inline-input common-search-formtype"
              style="margin-right: 13px;display:inline-block;width:172px;"
              v-model="srarch_lable_name"
              :fetch-suggestions="querySearch"
              placeholder="请输入标签"
              @select="handleSelect"
            ></el-autocomplete>
            <el-button type="primary" class="add-btn" style="float: right;" @click="editLable('添加')">新建标签</el-button>
            <el-button type="primary" class="add-btn" style="float: right;margin-right:16px" @click="getData(1)">全部标签</el-button>
            <el-button type="primary" class="add-btn" style="float: right;margin-right:16px" @click="getData(2)">搜索</el-button>
          </el-col>
        </el-row>
        <el-row>
          <div class="con_lable" v-if="searchTrue" :class="{ active: (storageList.length>20) }">
            <ul style="display: flex;flex-direction: column;flex-wrap: wrap;height: 100%;">
              <my-tree v-for="(item, index) in list" :key="item.id" v-model="list[index]" @delectCustomerTag="delectCustomerTag" @editLable="editLable" @getStart="getStart" @getOver="getOver" @getEnd="getEnd" :pid="pid" :editId="editId" @Hierarchy="Hierarchy" @statisticsPush="statisticsPush" @lableRemove="lableRemove"></my-tree>
            </ul>
          </div>
          <div class="con_lable" v-else style="height:auto">
            <ul>
              <li v-for="item in storageList" :key="item.id" style="width: 340px;float: left;">
                <div class="lable_detail">
                  <div class="lable_detail_num" @click="statisticsPush(item.id, item.name)">
                    <p class="lable_detail_p" style="width:188px;">{{item.name}}</p>
                    <!-- <span>{{item.children? item.children.length : 0}}<i v-if="item.children" class="el-icon-arrow-down" style="margin-right: 5px;float: right;font-size: 12px;"></i></span> -->
                    <span style="border: none;">{{item.user_num}}</span>
                  </div>
                  <div class="lable_detail_icon">
                    <img v-if="item.pid !== 0" src="../../assets/images/yichu.png" style="height:13px;margin-right:5px" @click="lableRemove(item.id, item.name)">
                    <i class="el-icon-edit" style="color:#018dfc;margin-right:5px;" @click="editLable(item.pid, item.name, item.id)"></i>
                    <i class="el-icon-delete" style="color:red" @click="delectCustomerTag(item.id, item.child.length)"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </el-row>
      </el-main>
    </el-container>

    <el-dialog class="cellDialog base-dialog" :title="editTitle" :visible.sync="addLable" width="520px">
      <el-form ref="addForm">
        <el-form-item label="标签名称:" label-width="80px">
          <el-input class="stockInput" type="text" v-model="editLableName" auto-complete="off" placeholder="请输入标签名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="addLable = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="addLableTrue">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 删除弹窗 -->
    <el-dialog
      class="cellDialog base-dialog"
      title="提示"
      :visible.sync="delectLable"
      width="520px"
      :before-close="handleClose">
      <div style="width:216px;margin:0 auto;text-align:left;">
        <p><i class="el-icon-warning" style="color:71d870;margin-right:5px;"></i>该标签含一个或多个子标签</p>
        <el-radio v-model="is_all" label="1">删除所有子标签</el-radio>
        <el-radio v-model="is_all" label="0" style="margin:1em 0;">只删除该标签，不删除子标签</el-radio>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="delectLable = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="delectLableTrue">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import myTree from './tree-label'
import draggable from 'vuedraggable'
import { getCustomerTag, editCustomerTag, addCustomerTag, delectCustomerTag, getTagsList } from '@/api/customer.js'
export default {
  name: 'customerLabel',
  data () {
    return {
      editTitle: '',
      editLableName: '',
      editId: '',
      pid: '',
      editPid: '',
      addLable: false,
      srarch_lable_name: '',
      searchTrue: true,
      list: [],
      storageList: [],
      delectId: '',
      is_all: '1',
      delectLable: false // 删除弹窗
    }
  },
  methods: {
    // 跳转标签统计页面
    statisticsPush(id, name) {
      router.push({
        path: '/home/customer-label-statistics',
        query: {id: id, name: name}
      })
    },
    querySearch(queryString, cb) {
      let nillArray = []
      if (queryString === '') {
        cb(nillArray)
        return
      }
      getTagsList(queryString).then(res => {
        let array = []
        for (let item of res.data.data.list) {
          array.push({
            value: item.name,
            id: item.id
          })
        }
        cb(array)
      })
    },
    handleSelect(item) {
      console.log(item)
    },
    editLable(pid, name, id) {
      if (pid === '添加') {
        this.editTitle = '添加标签'
      } else {
        this.editTitle = '编辑标签'
        this.pid = pid
        this.editLableName = name
        this.editId = id
      }
      this.addLable = true
    },
    handleClose() {
      this.editLableName = ''
      this.editId = ''
      this.pid = ''
    },
    // 处理数据树
    toTree(data, parent_id) {
      var tree = []
      var temp
      for (var i = 0; i < data.length; i++) {
        if (data[i].pid == parent_id || typeof data[i].pid == 'undefined') {
          var obj = data[i]
          temp = this.toTree(data, data[i].id)
          if (temp.length > 0) {
            obj.children = temp
            obj.childLength = temp.length
          } else {
            obj.childLength = 0
          }
          tree.push(obj)
        }
      }
      return tree
    },
    getData(num) {
      if (num === 1) {
        this.list = []
        this.srarch_lable_name = ''
        this.searchTrue = true
      } else if (num === 2) {
        this.searchTrue = false
      }
      if (this.srarch_lable_name === '') {
        this.searchTrue = true
      }
      let _this = this
      let search = {
        name: this.srarch_lable_name
      }
      getCustomerTag(search).then(res => {
        if (res.data.code === 0) {
          console.log(res.data.data)
          // for (let item of res.data.data.list) {
          //   item.show = true
          // }
          let result = res.data.data.list
          _this.storageList = res.data.data.list
          _this.list = _this.toTree(result, '')
          console.log(_this.list)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 添加编辑标签
    addLableTrue() {
      if (this.editTitle === '添加标签') {
        addCustomerTag(this.editLableName).then(res => {
          if (res.data.code === 0) {
            console.log(res.data)
            _g.toastMsg('success', res.data.error)
            this.addLable = false
            this.getData()
            this.handleClose()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      } else {
        let data = {
          name: this.editLableName,
          pid: this.pid
        }
        editCustomerTag(data, this.editId).then(res => {
          if (res.data.code === 0) {
            console.log(res.data)
            _g.toastMsg('success', res.data.error)
            if (this.addLable) {
              this.addLable = false
              this.list = []
              this.getData()
            }
            if (this.pid === 0) {
              this.list = []
              this.getData()
            }
            this.handleClose()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }
    },
    // 删除标签
    delectCustomerTag(id, childLength) {
      if (childLength === 0) {
        this.$confirm('确认删除该标签?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delectCustomerTag(id, 0).then(res => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
              this.list = []
              this.getData()
            } else {
              _g.toastMsg('error', res.data.error)
            }
          })
        })
      } else {
        this.delectLable = true
        this.delectId = id
      }
    },
    // 删除标签 弹窗true
    delectLableTrue() {
      delectCustomerTag(this.delectId, this.is_all).then(res => {
        if (res.data.code === 0) {
          this.delectLable = false
          _g.toastMsg('success', res.data.error)
          this.list = []
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 层级关系显示隐藏
    Hierarchy(id) {
      if (document.getElementById(id).getElementsByClassName('children')[0].style.display === 'none') {
        document.getElementById(id).getElementsByClassName('children')[0].style.display = 'block'
      } else {
        document.getElementById(id).getElementsByClassName('children')[0].style.display = 'none'
      }
      let i = document.getElementById('i' + id)
      if (i.getAttribute('class') === 'el-icon-arrow-down') {
        i.className = 'el-icon-arrow-up'
      } else {
        i.className = 'el-icon-arrow-down'
      }
    },
    // 标签移除变第一级
    lableRemove(id, name) {
      this.$confirm('确认移除该标签?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.editId = id
        this.editLableName = name
        this.editTitle = ''
        this.pid = 0
        this.addLableTrue()
      })
    },
    getStart (event, id, name, pid) {
      event.dataTransfer.setData('dd', 'id')
      console.log(event)
      this.editId = id
      this.editLableName = name
      this.editPid = pid
    },
    getOver(e, id) {
      this.pid = id
    },
    getEnd(e, id) {
      // var userAgent = navigator.userAgent
      // if (userAgent.indexOf('Firefox') > -1) {
      //   if (e.screenX <= 2180) {
      //     console.log('火狐移除了')
      //     this.editTitle = ''
      //     this.pid = 0
      //     this.addLableTrue()
      //   } else {
      //     if (this.pid !== this.editId) {
      //       let parent = document.getElementById(this.pid)
      //       let child = document.getElementById(this.editId)
      //       if (parent.getElementsByClassName('children').length > 0) {
      //         parent.getElementsByClassName('children')[0].appendChild(child)
      //       } else {
      //         let ul = document.createElement('ul')
      //         ul.setAttribute('class', 'children')
      //         parent.appendChild(ul).appendChild(child)
      //       }
      //       if (this.editPid !== 0) {
      //         this.listEdit(this.list, this.editPid, 2)
      //       }
      //       this.listEdit(this.list, this.pid, 1)
      //       this.listEditPid(this.list)
      //       console.log(this.list)
      //       this.editTitle = ''
      //       this.addLableTrue()
      //     }
      //   }
      // } else if (e.x <= 250) {
      //   console.log('移除了')
      //   this.editTitle = ''
      //   this.pid = 0
      //   this.addLableTrue()
      // } else {
      if (this.pid !== this.editId) {
        let parent = document.getElementById(this.pid)
        let child = document.getElementById(this.editId)
        if (parent.getElementsByClassName('children').length > 0) {
          parent.getElementsByClassName('children')[0].appendChild(child)
        } else {
          let ul = document.createElement('ul')
          ul.setAttribute('class', 'children')
          parent.appendChild(ul).appendChild(child)
        }
        if (this.editPid !== 0) {
          this.listEdit(this.list, this.editPid, 2)
        }
        this.listEdit(this.list, this.pid, 1)
        this.listEditPid(this.list)
        console.log(this.list)
        this.editTitle = ''
        this.addLableTrue()
      }
      // }
    },
    listEdit(num, id, i) {
      if (i !== 1) {
        for (let item of num) {
          if (item.id === id) {
            let length = item.childLength - 1
            item.name = ' ' + item.name
            item.childLength = length
            return
          }
          if (item.children) {
            this.listEdit(item.children, id, i)
          }
        }
      } else {
        for (let item of num) {
          if (item.id === id) {
            item.childLength = item.childLength + 1
            item.name = ' ' + item.name
            return
          }
          if (item.children) {
            this.listEdit(item.children, id, i)
          }
        }
      }
    },
    listEditPid(num) {
      for (let item of num) {
        if (item.id === this.editId) {
          item.pid = this.pid
          console.log('edit了')
          return
        }
        if (item.children) {
          this.listEditPid(item.children)
        }
      }
    }
  },
  components: {
    draggable,
    myTree
  },
  mounted() {
    this.getData()
  },
  created() {
  }
}
</script>

<style scoped>
.active{
  height: 1017px;
}
.table-title{
  text-align: left;
}
.grid-content-one{
  margin: 20px 24px 0;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.grid-content-one h4{
  margin: 0;
  line-height: 30px;
  color: #333;
  font-size: 14px;
}
.tip-content{
  font-size: 12px;
  color: #999;
}
.con_lable{
  min-height: 500px;
  overflow-x: auto;
  overflow-y: hidden;
  max-height: 1017px;
  background: #fff;
  margin: 0 24px;
  padding: 20px 0;
}
/*li标签*/
.con_lable li{
  list-style: none;
}
.lable_detail{
  width: 340px;
  height: 35px;
  margin-top: 15px;
  font-size: 14px;
  text-align: left;
}
.lable_detail_num{
  background: #f6faff;
  width: 250px;
  border: 1px solid #ececec;
  box-sizing: border-box;
  border-radius: 5px;
  height: 35px;
  line-height: 35px;
  text-align: left;
  padding-left: 10px;
  display: inline-block;
  float: left;
}
.lable_detail_num .lable_detail_p{
  margin:0;
  display: inline-block;
  width: 161px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.lable_detail:hover .lable_detail_num{
  border: 1px solid #1980FF;
}
.lable_detail:hover .lable_detail_icon{
  display: inline-block;
}
.lable_detail_num span{
  float: right;
  border-left: 1px solid #ececec;
  line-height: 15px;
  margin-top: 10px;
  width: 50px;
  text-align: center;
}
.lable_detail_icon{
  display: none;
  padding: 0 8px;
  cursor: pointer;
  line-height: 35px;
  height: 35px;
  margin: 0;
  float: left;
}
</style>
